import React from "react";
import { Link } from "react-router-dom";
import "../Pages/Main.css";

function BannerTransition() {
  const heroData = {
    title: "Empowering Healthcare Professionals",
    subtitle: "D-Right Technologies",
    description:
      "Experience innovation like never before with D-Right Technologies (Pvt.) Ltd. Explore our comprehensive suite of healthcare software programs, setting new standards in healthcare across Pakistan.",
    primaryCTA: {
      text: "Request a Demo",
      link: "/request-a-demo",
      className: "btn btn-brand-03 btn-rounded",
    },
    secondaryCTA: {
      text: "Explore Solutions",
      link: "#product-showcase",
      className: "btn btn-outline-brand-03 btn-rounded",
    },
    bgImage: "/assets/img/banner1.jpg",
  };

  return (
    <section
      className="position-relative bg-image pt-60 pb-100 home-hero-section"
      image-overlay="8"
    >
      <div
        className="background-image-wraper"
        style={{
          background: `url('${heroData.bgImage}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          opacity: 1,
        }}
      />
      <div className="container">
        <div className="row align-items-center min-vh-75 justify-content-center">
          <div className="col-lg-11 col-md-12 d-flex justify-content-center">
            <div className="hero-glass-card p-5 hero-glass-animated">
              {heroData.subtitle && (
                <span className="badge badge-primary mb-3 d-inline-block hero-glass-badge">
                  {heroData.subtitle}
                </span>
              )}
              <h1 className="font-weight-bold mb-4 hero-glass-title">
                {heroData.title}
              </h1>
              <p className="lead mb-4 hero-glass-description">
                {heroData.description}
              </p>
              <div className="action-btns mt-4 hero-glass-buttons">
                <Link
                  to={heroData.primaryCTA.link}
                  className={`${heroData.primaryCTA.className} mr-3 mb-3 hero-glass-btn-primary`}
                >
                  {heroData.primaryCTA.text}
                  <i className="fas fa-arrow-right pl-2"></i>
                </Link>
                <a
                  href={heroData.secondaryCTA.link}
                  className={`${heroData.secondaryCTA.className} mb-3 hero-glass-btn-secondary`}
                  onClick={(e) => {
                    e.preventDefault();
                    const element = document.querySelector(
                      heroData.secondaryCTA.link
                    );
                    if (element) {
                      element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }
                  }}
                >
                  {heroData.secondaryCTA.text}
                  <i className="fas fa-external-link-alt pl-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BannerTransition;
